import React from 'react';
import PersonRoundedIcon from '@material-ui/icons/PersonRounded';
import EditIcon from '@material-ui/icons/Edit';
import LockRoundedIcon from '@material-ui/icons/LockRounded';

import useAuth from 'hooks/useAuth';
import { ListCard, ListCardItem } from 'components';

import EmailResetDialog from './EmailResetDialog';
import PasswordResetDialog from './PasswordResetDialog';

const LoginCredentials: React.SFC = () => {
  const { user, sendPasswordReset } = useAuth();

  const [isPwdOpen, setIsPwdOpen] = React.useState(false);
  const [isEmailOpen, setIsEmailOpen] = React.useState(false);

  const handlePasswordReset = async () => {
    await sendPasswordReset(user.email);
    setIsPwdOpen(true);
  };

  const credentialsListItems: ListCardItem[] = [
    {
      leftIcon: <PersonRoundedIcon />,
      primaryText: user.email,
      secondaryText: 'Email Address',
      actionIcon: <EditIcon />,
      onActionClick: () => setIsEmailOpen(true),
    },
    {
      leftIcon: <LockRoundedIcon />,
      primaryText: '**********',
      secondaryText: 'Password',
      actionIcon: <EditIcon />,
      onActionClick: () => handlePasswordReset(),
    },
  ];

  return (
    <>
      <ListCard title="Login Credentials" reverseLabels listItems={credentialsListItems} />
      <PasswordResetDialog isOpen={isPwdOpen} onClose={() => setIsPwdOpen(false)} />
      <EmailResetDialog isOpen={isEmailOpen} onClose={() => setIsEmailOpen(false)} />
    </>
  );
};

export default LoginCredentials;
